import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useProviderAccountsFilterFields } from './hooks/useProviderAccountsFilterFields';

export const ProviderAccountsListFilterForm: React.FC = () => {
  const fields = useProviderAccountsFilterFields();

  return <FilterFields fields={fields} />;
};
